import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'default' | 'secondary' | 'outline';
  size?: 'default' | 'sm' | 'xs';
  className?: string;
  disabled?: boolean;
}
export function Button({
  children,
  onClick,
  variant = 'default',
  size = 'default',
  className = '',
  disabled = false
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors';
  const variantStyles = {
    default: 'bg-gray-800 text-white hover:bg-gray-700',
    secondary: 'bg-gray-100 text-gray-800 hover:bg-gray-200',
    outline: 'border border-gray-300 bg-white text-gray-800 hover:bg-gray-50'
  };
  const sizeStyles = {
    default: 'px-4 py-2 text-sm',
    sm: 'px-3 py-1.5 text-sm',
    xs: 'px-2 py-1 text-xs'
  };
  return <button onClick={onClick} disabled={disabled} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`} data-id="element-466">
      {children}
    </button>;
}